import React, { Component } from 'react';
import { connect } from 'react-redux';
//import { Route, HashRouter } from 'react-router-dom';
import { UIRouter, UIView } from '@uirouter/react';
import { router } from './router';
import { GeckoGlobal } from '@geckolabs/gecko-react-ui';
import './animate.css';
import './global.scss';
// import RsvpPage from './pages/rsvp/rsvp.jsx';
// import EventsPage from './pages/events/events.jsx';
// import FallbackPage from './pages/fallback/fallback.jsx';

class App extends Component {

    render() {
        return (
            <div>

                <UIRouter router={router}>

                    <div className="App">

                        <GeckoGlobal />

                        <UIView/>

                    </div>

                </UIRouter>

            </div>
        );
    }

}

const mapStateToProps = store => {
    return {
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
    }
}

export default connect(
    mapStateToProps, 
    mapDispatchToProps,
)(App);




/*<div className="App">

                <GeckoGlobal />



                <HashRouter>
                    <div>
                        <Route path="/rsvp/:accountId/:contactId/:eventId" component={RsvpPage} />
                        <Route path="/events/:contactId" component={EventsPage}/>
                        <Route path="/" exact component={FallbackPage}/>
                    </div>
                </HashRouter>

            </div>*/